import React from 'react';
import { CartContextProvider, useCartContext } from './useCartContext';
import { SwapCartBundleModal } from '../../SwapCartBundleModal/SwapCartBundleModal';
import { Prompt } from 'react-router';

const SwapCartBundleModalContextWrapper = () => {
  const { swapCartBundleState, setSwapCartBundleState } = useCartContext();
  return <SwapCartBundleModal bundleState={[swapCartBundleState, setSwapCartBundleState]} />;
};

const PromptContextWrapper = () => {
  const { cartId, checkIfTheUserCanNavigate } = useCartContext();
  return (
    /*
        Prompt: Used to executeCartAction before the user navigate away from a page.
        when: currently it checkIfTheUserCanNavigate if there is a currentBundleId in the cart
        message: true to allow navigation, false to prevent navigation
      */
    <Prompt when={!!cartId} message={checkIfTheUserCanNavigate} />
  );
};

export const CartProvider: React.FC = ({ children, ...props }) => {
  return (
    <CartContextProvider {...props}>
      {children}
      <SwapCartBundleModalContextWrapper />
      <PromptContextWrapper />
    </CartContextProvider>
  );
};
